import {Parameter, ToolboxExtractionExtraction} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum ExtractionMode {
	TEXT = "text",
	URL = "url",
	WORDS = "words",
	IMAGES = "images"
}

export class PortalToolboxExtractionExtraction extends ToolboxExtractionExtraction implements Parameter {
	public mode?: ExtractionMode;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : ExtractionMode.TEXT;
	}

	public static getModeDefault(): ExtractionMode {
		return ExtractionMode.TEXT;
	}

	public static fromJson(data: any): PortalToolboxExtractionExtraction {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxExtractionExtraction(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode
		};
	}

	public clone(): PortalToolboxExtractionExtraction {
		return PortalToolboxExtractionExtraction.fromJson(this.toJson());
	}
}